export const diagnosisSummary = {
  title: 'Diagnosis Summary',
  columns: [
    {
      label: 'Date',
    },
    {
      label: 'Code',
    },
    {
      label: 'Description',
    },
  ],
  rows: [{ values: ['Apr 13, 2022', 'ER', 'Sudden weight loss'] }],
};

export const servicesSummary = {
  title: 'Services Summary',
  columns: [
    {
      label: 'Date',
    },
    {
      label: 'Type',
    },
    {
      label: 'Code',
    },
  ],
  rows: [
    {
      values: ['May 01, 2022', 'Counseling', 32],
    },
    {
      values: ['Apr 28, 2022', 'Impatient Hospitalization', 33],
    },
    {
      values: ['Apr 13, 2022', 'Emergency Room Visit', 34],
    },
  ],
};

export const medicationSummary = {
  title: 'Medication Summary',
  columns: [
    {
      label: 'Date',
    },
    {
      label: 'Type',
    },
    {
      label: 'Code',
    },
  ],
  rows: [
    {
      values: ['Apr 23, 2022', 'Muscle relaxing', 'MR'],
    },
    {
      values: ['Apr 14, 2022', 'Local anaesthetics', 'LA'],
    },
    {
      values: ['Apr 01, 2022', 'Gastric protection', 'GP'],
    },
  ],
};

export const servicesSummaryExpanded = {
  title: 'Services Summary',
  columns: [
    {
      label: 'Data',
    },
    {
      label: 'Type',
    },
    {
      label: 'Code',
    },
    {
      label: 'Provider',
    },
    {
      label: 'End Date',
    },
    {
      label: 'Services Received',
    },
    {
      label: 'Diagnoses',
    },
    {
      label: 'Data Source',
    },
  ],
  rows: [
    {
      values: [
        'May 01, 2022',
        'Counseling',
        32,
        'PIW - Inpatient',
        'May 03, 2022',
        'Peer Coaching',
        '-',
        'Manual',
      ],
    },
    {
      values: [
        'Apr 28, 2022',
        'Impatient Hospitalization',
        33,
        'George Washington University Hospital',
        'Apr 30, 2022',
        'Detox',
        'Opioid Overdose',
        'Manual',
      ],
    },
    {
      values: [
        'Apr 13, 2022',
        'Emergency Room Visit',
        34,
        'Community Family Life Services',
        'Apr 16, 2022',
        'Detox',
        'Overdose',
        'Manual',
      ],
    },
  ],
};

export const vitalsSummary = {
  title: 'Vitals Summary',
  columns: [{ label: 'Date' }, { label: 'Code' }, { label: 'Description' }],
};

export const allergiesSummary = {
  title: 'Allergies Summary',
  columns: [{ label: 'Date' }, { label: 'Code' }, { label: 'Description' }],
};

export const labsSummary = {
  title: 'Labs Summary',
  columns: [{ label: 'Date' }, { label: 'Code' }, { label: 'Description' }],
};

export const personalDetails = {
  title: 'Personal Details',
  fields: [
    {
      label: 'Phone',
      values: [
        {
          favorite: true,
          type: 'Mobile',
          value: '714-555-1243',
        },
        {
          type: 'Landline',
          value: '609-860-0087',
        },
      ],
    },
    {
      label: 'Email',
      values: [
        {
          favorite: true,
          type: 'Personal',
          value: 'lindysus932@gmail.com',
        },
        {
          type: 'Work',
          value: 'linda.sussman@exeltis.com',
        },
      ],
    },
    {
      label: 'Address',
      values: ['5 Main St, Orange, CA, 92834', '1805 Dane Street Spokane Valley, WA, 99206'],
    },
    {
      label: 'Alias',
      value: 'Lindy',
    },
    {
      label: 'MS.',
      value: 'Single',
    },
    {
      label: 'Race',
      value: 'White',
    },
    {
      label: 'SO.',
      value: 'Heterosexual',
    },
    {
      label: 'SSN',
      value: '555-12-1511',
    },
  ],
};

export const admissionDetails = {
  title: 'Admission Details',
  fields: [
    {
      label: 'Status',
      values: [{ value: 'Enrolled' }],
    },
    {
      label: 'Location',
      values: [{ value: 'New Fullerton Shelter' }],
    },
    {
      label: 'Admission Date',
      values: [{ value: 'May 01, 2022' }],
    },
    {
      label: 'Discharge Date',
      values: [{ value: 'N/A' }],
    },
    {
      label: 'Referrer',
      values: [{ value: 'St. Jude Hospital' }],
    },
  ],
};

export const careTeam = {
  title: 'Care Team',
  persons: [
    {
      avatar: 'https://minimal-assets-api-dev.vercel.app/assets/images/avatars/avatar_2.jpg',
      displayName: 'Ted Ortiz',
      role: 'Case Manager',
      email: 'ted.ortiz@ccsmgmt.com',
      phone: '509-220-9846',
    },
    {
      avatar: 'https://minimal-assets-api-dev.vercel.app/assets/images/avatars/avatar_3.jpg',
      displayName: 'Jane Adams',
      role: 'Housing Navigator',
      email: 'jane.adams@ccsmgmt.com',
      phone: '770-734-0901',
    },
    {
      avatar: 'https://minimal-assets-api-dev.vercel.app/assets/images/avatars/avatar_4.jpg',
      displayName: 'James Fallon',
      role: 'Medical Coordinator',
      email: 'james.fallon@ccsmgmt.com',
      phone: '972-605-1008',
    },
    {
      avatar: 'https://minimal-assets-api-dev.vercel.app/assets/images/avatars/avatar_5.jpg',
      displayName: 'Ana Chavez',
      role: 'SUD Counselor',
      email: 'ana.chavez@ccsmgmt.com',
      phone: '617-710-2825',
    },
  ],
};

export const actitivitiesAndReferrals = [
  {
    date: 'Apr 13, 2022',
    type: 'Task/Notes',
    activity: 'Summary of Tasks',
  },
  {
    date: 'Apr 03, 2022',
    type: 'Task/Notes',
    activity: 'Injury',
  },
];

export const assessments = [
  {
    values: ['May 01, 2022', 'SDoH', 'Prepare', 'James Fallon', 'Behavioral Health', 'PHQ9'],
    date: 'May 01, 2022',
    type: 'SDoH',
    assessment: 'Prepare',
    staff: 'James Fallon',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'in-progress',
  },
  {
    values: ['Apr 03, 2022', 'Case Note', 'Injury', 'Ana Chavez', 'Behavioral Health', 'PHQ9'],
    date: 'Apr 03, 2022',
    type: 'Case Note',
    assessment: 'Injury',
    staff: 'Ana Chavez',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'in-progress',
  },
  {
    values: ['May 01, 2022', 'SDoH', 'Prepare', 'James Fallon', 'Behavioral Health', 'PHQ9'],
    date: 'May 01, 2022',
    type: 'SDoH',
    assessment: 'Prepare',
    staff: 'James Fallon',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['Apr 03, 2022', 'Case Note', 'Injury', 'Ana Chavez', 'Behavioral Health', 'PHQ9'],
    date: 'Apr 03, 2022',
    type: 'Case Note',
    assessment: 'Injury',
    staff: 'Ana Chavez',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['May 01, 2022', 'SDoH', 'Prepare', 'James Fallon', 'Behavioral Health', 'PHQ9'],
    date: 'May 01, 2022',
    type: 'SDoH',
    assessment: 'Prepare',
    staff: 'James Fallon',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['Apr 03, 2022', 'Case Note', 'Injury', 'Ana Chavez', 'Behavioral Health', 'PHQ9'],
    date: 'Apr 03, 2022',
    type: 'Case Note',
    assessment: 'Injury',
    staff: 'Ana Chavez',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['May 01, 2022', 'SDoH', 'Prepare', 'James Fallon', 'Behavioral Health', 'PHQ9'],
    date: 'May 01, 2022',
    type: 'SDoH',
    assessment: 'Prepare',
    staff: 'James Fallon',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['Apr 03, 2022', 'Case Note', 'Injury', 'Ana Chavez', 'Behavioral Health', 'PHQ9'],
    date: 'Apr 03, 2022',
    type: 'Case Note',
    assessment: 'Injury',
    staff: 'Ana Chavez',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['May 01, 2022', 'SDoH', 'Prepare', 'James Fallon', 'Behavioral Health', 'PHQ9'],
    date: 'May 01, 2022',
    type: 'SDoH',
    assessment: 'Prepare',
    staff: 'James Fallon',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['Apr 03, 2022', 'Case Note', 'Injury', 'Ana Chavez', 'Behavioral Health', 'PHQ9'],
    date: 'Apr 03, 2022',
    type: 'Case Note',
    assessment: 'Injury',
    staff: 'Ana Chavez',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['May 01, 2022', 'SDoH', 'Prepare', 'James Fallon', 'Behavioral Health', 'PHQ9'],
    date: 'May 01, 2022',
    type: 'SDoH',
    assessment: 'Prepare',
    staff: 'James Fallon',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['Apr 03, 2022', 'Case Note', 'Injury', 'Ana Chavez', 'Behavioral Health', 'PHQ9'],
    date: 'Apr 03, 2022',
    type: 'Case Note',
    assessment: 'Injury',
    staff: 'Ana Chavez',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['May 01, 2022', 'SDoH', 'Prepare', 'James Fallon', 'Behavioral Health', 'PHQ9'],
    date: 'May 01, 2022',
    type: 'SDoH',
    assessment: 'Prepare',
    staff: 'James Fallon',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
  {
    values: ['Apr 03, 2022', 'Case Note', 'Injury', 'Ana Chavez', 'Behavioral Health', 'PHQ9'],
    date: 'Apr 03, 2022',
    type: 'Case Note',
    assessment: 'Injury',
    staff: 'Ana Chavez',
    category: 'Behavioral Health',
    name: 'PHQ9',
    status: 'completed',
  },
];

export const carePlan = [
  {
    priority: 'Normal',
    role: 'Manager',
    goal: 'Erradicate vectors',
    lob: 'Demo',
    condition: 'General',
    goalGroup: 'Social Goal Group',
    intervention: 'Proper sanitation',
    status: 'In Progress',
    signOff: 'Yes',
    date: 'Jun 1,22',
    term: 'Short',
    appt: 'No',
  },
  {
    priority: 'Low',
    role: 'Manager',
    goal: 'Avoid fluid loss',
    lob: 'Demo',
    condition: 'General',
    goalGroup: 'Social Goal Group',
    intervention: 'Monitor vital signs',
    status: 'In Progress',
    signOff: 'Yes',
    date: 'Jun 1,22',
    term: 'Short',
    appt: 'No',
  },
];

export const mockPersons = [
  {
    id: 1,
    avatar: 'https://minimal-assets-api-dev.vercel.app/assets/images/avatars/avatar_1.jpg',
    name: 'Alejandra Penny Sanz',
    phone: '54157292',
    familyId: 112244,
    birthDate: new Date('1980-12-04'),
    fullName: 'Alejandra Penny Sanz',
    givenName: 'Alejandra',
    familyName: 'Penny Sanz',
    phoneNumbers: [{ value: '(03) 5555 6473' }, { value: '(03) 5555 6473' }],
    photo: [
      {
        contentType: 'image/jpeg',
        creation: '2022-06-14T14:48:38.876393+00:00',
        data: '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',
        title: 'photoExample',
      },
    ],
  },
  {
    id: 2,
    avatar: 'https://minimal-assets-api-dev.vercel.app/assets/images/avatars/avatar_3.jpg',
    name: 'George Sussman',
    email: 'gsussman77@gmail.com',
    phone: '267-323-7978',
    familyId: 112244,
    relationship: 'father',
    birthDate: new Date('1961-09-15'),
    fullName: 'George Sussman',
    givenName: 'George',
    familyName: 'Sussman',
    phoneNumbers: [{ value: '267-323-7978' }],
    photo: [
      {
        contentType: 'image/jpeg',
        creation: '2022-06-14T14:48:38.876393+00:00',
        data: '',
        title: 'photoExample',
      },
    ],
  },
  {
    id: 4,
    avatar: 'https://minimal-assets-api-dev.vercel.app/assets/images/avatars/avatar_4.jpg',
    name: 'Rita Sussman',
    email: 'rita.sussman@outlook.com',
    phone: '412-270-7930',
    familyId: 112244,
    relationship: 'sister',
    birthDate: new Date('1982-02-03'),
    fullName: 'Rita Sussman',
    givenName: 'Rita',
    familyName: 'Sussman',
    phoneNumbers: [{ value: '412-270-7930' }],
    photo: [
      {
        contentType: 'image/jpeg',
        creation: '2022-06-14T14:48:38.876393+00:00',
        data: '',
        title: 'photoExample',
      },
    ],
  },
  {
    id: 3,
    avatar: 'https://minimal-assets-api-dev.vercel.app/assets/images/avatars/avatar_5.jpg',
    name: 'John Ballart',
    email: 'jsballard@gmail.com',
    phone: '505-988-3112',
    relationship: 'friend',
    birthDate: new Date('1981-07-18'),
    fullName: 'John Ballart',
    givenName: 'John',
    familyName: 'Ballart',
    phoneNumbers: [{ value: '505-988-3112' }],
    photo: [
      {
        contentType: 'image/jpeg',
        creation: '2022-06-14T14:48:38.876393+00:00',
        data: '',
        title: 'photoExample',
      },
    ],
  },
];

export const _vitals = {
  entry: [
    {
      fullUrl:
        'https://dev-fhir.patientholistics.app/fhir/Observation/c3c337ab-b5ee-4b19-a5e1-8cefc16bd20c',
      resource: {
        code: {
          coding: [
            {
              code: '29463-7',
              display: 'Body Weight',
              system: 'http://loinc.org',
            },
            {
              code: '3141-9',
              display: 'Body weight Measured',
              system: 'http://loinc.org',
            },
          ],
        },
        effectivePeriod: {
          end: '2022-04-05T10:30:10+01:00',
          start: '2022-04-02T10:30:10+01:00',
        },
        encounter: {
          reference: 'Encounter/854c06de-af63-44dc-89e7-c7ffbac0e8ad',
        },
        id: 'c3c337ab-b5ee-4b19-a5e1-8cefc16bd20c',
        meta: {
          lastUpdated: '2022-06-16T13:36:44.998022+00:00',
          versionId: 'MTY1NTM4NjYwNDk5ODAyMjAwMA',
        },
        performer: [
          {
            display: 'CareTeam name',
            reference: 'CareTeam/078a5765-dfd7-41db-8d44-90ee7701c1c4',
          },
        ],
        resourceType: 'Observation',
        status: 'registered',
        subject: {
          reference: 'Patient/81d5f8c4-f0bb-49ee-9ee2-183d30160dc2',
        },
        valueCodeableConcept: {
          coding: [
            {
              code: '1234',
              display: 'Impact score',
              system: 'urlSystem',
            },
          ],
          text: '72',
        },
      },
      search: {
        mode: 'match',
      },
    },{
      fullUrl:
        'http://dev-fhir.patientholistics.app/fhir/Observation/c3c337ab-b5ee-4b19-a5e1-8cefc16bd20c',
      resource: {
        code: {
          coding: [
            {
              code: '29463-7',
              display: 'Body Weight',
              system: 'http://loinc.org',
            },
            {
              code: '3141-9',
              display: 'Body weight Measured',
              system: 'http://loinc.org',
            },
          ],
        },
        effectivePeriod: {
          end: '2022-04-05T10:30:10+01:00',
          start: '2022-04-02T10:30:10+01:00',
        },
        encounter: {
          reference: 'Encounter/854c06de-af63-44dc-89e7-c7ffbac0e8ad',
        },
        id: 'c3c337ab-b5ee-4b19-a5e1-8cefc16bd20c',
        meta: {
          lastUpdated: '2022-06-16T13:36:44.998022+00:00',
          versionId: 'MTY1NTM4NjYwNDk5ODAyMjAwMA',
        },
        performer: [
          {
            display: 'CareTeam name',
            reference: 'CareTeam/078a5765-dfd7-41db-8d44-90ee7701c1c4',
          },
        ],
        resourceType: 'Observation',
        status: 'registered',
        subject: {
          reference: 'Patient/81d5f8c4-f0bb-49ee-9ee2-183d30160dc2',
        },
        valueCodeableConcept: {
          coding: [
            {
              code: '1234',
              display: 'Impact score',
              system: 'urlSystem',
            },
          ],
          text: '72',
        },
      },
      search: {
        mode: 'match',
      },
    },{
      fullUrl:
        'http://dev-fhir.patientholistics.app/fhir/Observation/c3c337ab-b5ee-4b19-a5e1-8cefc16bd20c',
      resource: {
        code: {
          coding: [
            {
              code: '29463-7',
              display: 'Body Weight',
              system: 'http://loinc.org',
            },
            {
              code: '3141-9',
              display: 'Body weight Measured',
              system: 'http://loinc.org',
            },
          ],
        },
        effectivePeriod: {
          end: '2022-04-05T10:30:10+01:00',
          start: '2022-04-02T10:30:10+01:00',
        },
        encounter: {
          reference: 'Encounter/854c06de-af63-44dc-89e7-c7ffbac0e8ad',
        },
        id: 'c3c337ab-b5ee-4b19-a5e1-8cefc16bd20c',
        meta: {
          lastUpdated: '2022-06-16T13:36:44.998022+00:00',
          versionId: 'MTY1NTM4NjYwNDk5ODAyMjAwMA',
        },
        performer: [
          {
            display: 'CareTeam name',
            reference: 'CareTeam/078a5765-dfd7-41db-8d44-90ee7701c1c4',
          },
        ],
        resourceType: 'Observation',
        status: 'registered',
        subject: {
          reference: 'Patient/81d5f8c4-f0bb-49ee-9ee2-183d30160dc2',
        },
        valueCodeableConcept: {
          coding: [
            {
              code: '1234',
              display: 'Impact score',
              system: 'urlSystem',
            },
          ],
          text: '72',
        },
      },
      search: {
        mode: 'match',
      },
    },
  ],
  link: [
    {
      relation: 'search',
      url: 'http://dev-fhir.patientholistics.app/fhir/Observation/?',
    },
    {
      relation: 'first',
      url: 'http://dev-fhir.patientholistics.app/fhir/Observation/?',
    },
    {
      relation: 'self',
      url: 'http://dev-fhir.patientholistics.app/fhir/Observation/?',
    },
  ],
  resourceType: 'Bundle',
  total: 1,
  type: 'searchset',
};
